import { render, staticRenderFns } from "./ThresholdsTable.vue?vue&type=template&id=9d0c6b98"
import script from "./ThresholdsTable.vue?vue&type=script&lang=js"
export * from "./ThresholdsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports